import styled from 'styled-components'
import { Badge, DataGridHeading, DataGridRow } from '@conserveit/blocks'

export const Wrapper = styled.div`
  position: relative;
`

export const Scrollable = styled.div`
  position: relative;
  max-height: 360px;
  overflow-y: scroll;
`

export const GridBadge = styled(Badge)`
  height: 16px;
`
export const StyleDataGridHeading = styled(DataGridHeading)`
  &:focus {
    outline: none;
  }

  &.right-alignment {
    justify-content: flex-end;
  }
`

export const Row = styled(DataGridRow)`
  .action-cell {
    i {
      font-style: italic;
    }
    justify-content: flex-end;
  }
  .action-link {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`
